import useCheckPC from 'hooks/useCheckPC';
import { useDarkMode } from '../context/DarkModeContext';
import { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

const Filter = ({ closeNav, closeHeaderNav, showLoading }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { darkMode } = useDarkMode();
  const listRef = useRef(null);
  const { isMobile, isTabletSmall } = useCheckPC();
  const selectedColor = darkMode ? 'var(--color-white)' : 'var(--color-black)';
  const unselectedColor = darkMode ? 'var(--color-grey)' : '';

  const handleInputChange = filter => {
    setSearchParams({ filter: filter });
    showLoading();
    !isMobile && !isTabletSmall ? closeNav() : closeHeaderNav();
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (listRef.current) {
      const listItems = listRef.current.children;

      Array.from(listItems).forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('show');
        }, index * 50);
      });
    }
  }, []);

  return (
    <ul className={'menu-items'} ref={listRef}>
      {filters.map((filter, index) => {
        const filterParam = searchParams.get('filter');
        const sortPararm = searchParams.get('sort');
        const isFilterSelected =
          filterParam === filter || (filterParam === null && sortPararm === null ? filter === 'All' : '');

        return (
          <li key={filter}>
            <input id={filter} type={'radio'} onChange={() => handleInputChange(filter)} checked={isFilterSelected} />
            <label htmlFor={filter}>
              <span
                className={'checkbox'}
                style={{ backgroundColor: isFilterSelected ? selectedColor : unselectedColor }}
              ></span>
              {filter && <span style={{ color: isFilterSelected ? selectedColor : unselectedColor }}>{filter}</span>}
            </label>
          </li>
        );
      })}
    </ul>
  );
};

export default Filter;

const filters = [
  'All',
  'Outerwear',
  'Shirts',
  'Pants',
  'Knits',
  'Tops',
  'Sweatshirts',
  'Tees',
  'Headwear',
  'Underwear',
  'Bags',
  'Accessories',
  'Lookbook',
];
